import _ from 'lodash'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import select from 'scoreboard-select'
import template from './group-list-filter.hbs'
import groupType from './group-type'

var GroupListFilter = Backbone.View.extend({

	events: {
    	'change .sort-by': '_changeSort',
		'change .group-type': '_changeGroupFilter'
	},

	initialize: function (options) {
		this.options = options || {}
		this.typeLabels = this.options.typeLabels
		this.type = this.options.type || 'all'
		this.sortDirection = this.options.sortDirection
	},

	render: function(){
    	var context = {}
	    this.$el.empty().append(template(context))

		this.sortDropdown = this.$('select.sort-by')
		this.sortDropdown.val(this.sortDirection)

		this.typeDropdown = this.$('select.group-type')
		this.typeDropdown.append(new Option(i18n.get('admin.group.groupType.all'), 'all'))
		_.each(this.typeLabels, function(type) {
			var label = groupType.label(type)
			this.typeDropdown.append(new Option(label, type))
		}.bind(this))
		this.typeDropdown.val(this.type)

		select(this.el.querySelectorAll('select'))
		return this
	},

	_changeGroupFilter: function(e){
		var type = this.typeDropdown.val()
		this.trigger('type', type === 'all' ? undefined : type)
	},

	_changeSort: function(e){
		this.trigger('sort', this.sortDropdown.val())
	}

})

export default GroupListFilter

GroupListFilter.__filename__ = 'admin/principals/groups/group-list-filter.js'
